import type { PropsWithChildren } from "react";
import { Header } from "../components/Header";

type Props = PropsWithChildren<{
  title?: string;
}>;

export function Layout({ children }: Props) {
  return (
    <>
      <Header />

      <>{children}</>
    </>
  );
}
